import { useEffect, useState } from 'react';
import { BreakpointWidths } from '../../../../../_helpers/breakpoints';
import { useMediaQuery } from '../../../../../_helpers/hooks/useMediaQuery';

const mobileWidth = BreakpointWidths['SM'] - 1;

export const useIsSideRailOn = (): boolean => {
	const [isSideRailOn, setIsSideRailOn] = useState<boolean>(true);

	const isPortraitMobileDevice = useMediaQuery(
		`screen and (max-width: ${mobileWidth}px) and (orientation: portrait)`
	);
	const isLandscapeMobileDevice = useMediaQuery(
		`screen and (max-height: ${mobileWidth}px) and (orientation: landscape) and (pointer: coarse)`
	);

	useEffect(() => {
		setIsSideRailOn(!isPortraitMobileDevice && !isLandscapeMobileDevice);
	}, [isPortraitMobileDevice, isLandscapeMobileDevice]);

	return isSideRailOn;
};
